// extracted by mini-css-extract-plugin
export var subtitle = "_bg-2";
export var title = "_bg-0";
export var titleNoWrap = "_bg-1";